import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, pdf } from '@react-pdf/renderer';
import PrintIcon from '@mui/icons-material/Print';
//hooks 
import {useFetchData} from '../../../../hooks/useFetchData/useFetchData';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';
import Client from '../client/client';
import classNames from 'classnames';
import CustomTableCell from '../../../shared/CustomTable/CustomTableCell';

let url = process.env.REACT_APP_API+ "/client/notRequests";

const DownloadPDFButton = ({ listClients }) => {


  const handleGeneratePDF = async () => {
    const blob = await pdf(<ReportClientsPDF listClients={listClients} />).toBlob();

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'relatorio_clientes.pdf';
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <IconButton onClick={handleGeneratePDF}>
      <PrintIcon />
    </IconButton>
  );
};

export default function ClientsNotRequests(props) {
  const [open, setOpen] = useState(false);
  const [client, setClient] = useState({});
  const [order, setOrder] = useState('last_request');
  const [orderBy, setOrderBy] = useState('desc');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter, setFilter] = useState('');
  const { ShowMessage, msgConfirm } = useShowMessages();
  const { data : listClients} = useFetchData(url, {filter: filter, page: page, rowsPerPage: rowsPerPage, 
                                                  startDate: props.startDate, endDate: props.endDate, order, orderBy}, props.changed, true);
   
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    props.handleChanged();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    props.handleChanged();
  };

  const handleEditUser = (values) =>{
    setClient(values);
    setOpen(true);
  }

  const getAlertCliente = async (client) => {
    if (client?.priority === 2) {
      await ShowMessage('warning', 'Cliente Preferencial', 'Esse cliente deve ser atendido com preferência!', 10);
    }
  }
  
  const handleSetFilter = (filter) => {
    setFilter(filter.target.value);
  }

  const handleSearch = () => {
    props.handleChanged();
  }

  const handleChangeOrder = (value) => {
    if (value === order) {
      setOrderBy(orderBy === 'asc' ? 'desc' : 'asc');
    } else {
      setOrder(value);
      setOrderBy('asc');
    }
    setPage(0);
    props.handleChanged();
  }

  const getIconOrder = () => {
    return orderBy === 'asc' ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />
  }

  return (
    <Box sx={{ width: '100%', height: '100%', mt: 0.5}}>
      <Client 
        open={open}
        setOpen={setOpen} 
        values={client}
        setValues={setClient}
        handleChanged={props.handleChanged}
      />
      <Paper elevation={3} sx={{ p: '2px 4px', display: 'flex',  mb: 2, border: '1px solid rgba(0, 0, 0, 0)', ':hover': { border: '1px solid' } }}>
        <InputBase
            sx={{ ml: 1, flex: 1, fontSize: '12px' }}
            placeholder="Busque por Nome Fantasia, Razão Social e CNPJ/CPF"
            value={filter}
            onChange={handleSetFilter}
            onKeyDown={(e) => {if(e.key === "Enter")handleSearch()}}
        />
        <IconButton type="button" sx={{ p: '10px' }} title='Buscar' onClick={handleSearch}>
            <SearchIcon />
        </IconButton>
        {
          listClients && listClients.length > 0 &&  
          <DownloadPDFButton listClients={listClients} />
        }
      </Paper >
      <Paper >
        <TableContainer sx={{ overflow: 'scroll', height: '60vh', fontSize: '11px'}} >
          <Table stickyHeader  sx={{ width: '100%' }} >
            <TableHead>
              <TableRow className="!whitespace-nowrap !w-full">
                  <CustomTableCell align="center" onClick={() => handleChangeOrder('id_gerente')}>Código Gerente {order === 'id_gerente' && getIconOrder()}</CustomTableCell> 
                  <CustomTableCell onClick={() => handleChangeOrder('nome_fantasia')}>Nome Fantasia {order === 'nome_fantasia' && getIconOrder()}</CustomTableCell>
                  <CustomTableCell align="center" onClick={() => handleChangeOrder('manutention_value')}>Manutenção {order === 'manutention_value' && getIconOrder()}</CustomTableCell>                     
                  <CustomTableCell align="center" onClick={() => handleChangeOrder('R.last_request')}>Último Atendimento {order === 'R.last_request' && getIconOrder()}</CustomTableCell>                     
                  {/* <CustomTableCell>Status</CustomTableCell>      */}
                  <CustomTableCell>Visualizar</CustomTableCell>                                              
              </TableRow>
            </TableHead>
            <TableBody>
            {listClients && listClients.map((row) => (
              <TableRow key={row.id} className="!whitespace-nowrap !w-full">
                <CustomTableCell align="center">{row.id_gerente}</CustomTableCell>
                <CustomTableCell component="th" scope="row">
                  {row.nome_fantasia}
                </CustomTableCell>  
                <CustomTableCell align="center">{row.manutention_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</CustomTableCell>              
                <CustomTableCell align="center">{row.last_request}</CustomTableCell>
                <CustomTableCell align="left">
                  <Button onClick={() => handleEditUser(row)}>
                      <VisibilityIcon />
                  </Button>
                </CustomTableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage='Registros por página'
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={(listClients && listClients) ? Math.ceil(listClients[0]?.total_geral) : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{fontSize: '12px'}}
        />
      </Paper>
    </Box>
  );
}

const ReportClientsPDF = ({ listClients }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 20,
      backgroundColor: '#fff'
    },
    tableRow: {
      flexDirection: 'row',
      borderBottom: '1 solid #ccc',
      padding: 5
    },
    tableCell: {
      flex: 1,
      fontSize: 10
    },
    header: {
      fontWeight: 'bold'
    }
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, styles.header]}>Código Gerente</Text>
          <Text style={[styles.tableCell, styles.header]}>Nome Fantasia</Text>
          <Text style={[styles.tableCell, styles.header]}>Manutenção</Text>
          <Text style={[styles.tableCell, styles.header]}>Último Atendimento</Text>
        </View>
        {listClients?.map((row) => (
          <View key={row.id} style={styles.tableRow}>
            <Text style={styles.tableCell}>{row.id_gerente}</Text>
            <Text style={styles.tableCell}>{row.nome_fantasia}</Text>
            <Text style={styles.tableCell}>
              {row.manutention_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}
            </Text>
            <Text style={styles.tableCell}>{row.last_request}</Text>
          </View>
        ))}
      </Page>
    </Document>
  );
};